// Copyright (c) 2017 Deere & Company

export default [
    ['pin'],
    ['model'],
    ['description'],
    ['dtac'],
    ['customerSummary', 'displayName'],
    ['pipType', 'value'],
    ['responsibleAccount', 'name'],
    ['responsibleAccount', 'location', 'city'],
    ['responsibleAccount', 'location', 'state'],
    ['responsibleAccount', 'account']
];



// WEBPACK FOOTER //
// ./src/pip/shared/constants/pip-products-filter-options.js